import React from "react";
import { Wrapper } from "./style";

const AppConfigurations = () => {
  return <Wrapper>app-configurations</Wrapper>;
};

export default AppConfigurations;
